import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { IconButton } from '@mui/material'

import { SliderWrapper, SlideWrapper, StyledSlider } from '@/components/Carousel/Carousel.styled'
import { cn } from '@/helpers/cn'
import { useMedia } from '@/hooks/useMedia'

import type { FC, PropsWithChildren } from 'react'
import type { CustomArrowProps, Settings } from 'react-slick'
import type { SxProps } from '@mui/material'

export const SliderButton: FC<CustomArrowProps & PropsWithChildren> = ({
  children,
  currentSlide,
  slideCount,
  ...arrowButtonProps
}) => (
  <IconButton
    sx={{}}
    key="123"
    {...arrowButtonProps}
    type="button"
    data-current={currentSlide}
    data-slidecount={slideCount}
  >
    {children}
  </IconButton>
)

const settings: Settings = {
  prevArrow: (
    <SliderButton data-testid="carousel-buttonPrevious">
      <ArrowBackIcon sx={{ height: 23, width: 23 }} color="secondary" fontSize="small" />
    </SliderButton>
  ),
  nextArrow: (
    <SliderButton data-testid="carousel-buttonNext">
      <ArrowForwardIcon sx={{ height: 23, width: 23 }} color="secondary" fontSize="small" />
    </SliderButton>
  ),

  autoplay: false,
  autoplaySpeed: 5000,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 2000,
  adaptiveHeight: true,
}

interface CarouselProps {
  /**
   * Array of JSX elements to be displayed as slides in the carousel
   */
  items: React.ReactNode[]
  sx?: SxProps
  settingsOverride?: Partial<Settings>
  heroBanner?: boolean
  pageDetails?: boolean
}

export const Carousel: FC<CarouselProps> = ({
  items,
  sx,
  settingsOverride,
  heroBanner = false,
  pageDetails = false,
}) => {
  const { isMobile } = useMedia()
  const showArrows = (isMobile && heroBanner) || pageDetails

  return (
    <SliderWrapper data-testid="carousel-component" sx={sx}>
      <StyledSlider
        className={cn(!isMobile && !pageDetails ? 'heroBanner' : pageDetails ? 'imageNavigation' : null)}
        {...{ ...settings, ...settingsOverride }}
        arrows={showArrows}
        dotsClass={heroBanner ? 'heroBanner slick-dots' : pageDetails ? 'slick-dots navImages' : 'slick-dots'}
        infinite={showArrows ? false : true}
      >
        {items?.map((item, index) => (
          <div key={index}>
            <SlideWrapper key={index}>{item}</SlideWrapper>
          </div>
        ))}
      </StyledSlider>
    </SliderWrapper>
  )
}
